'use client'
import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLazyQuery, useSubscription } from '@apollo/client'
import { RECENT_OVER } from '@/graphql/match/match.query'
import { isBottomReached } from '@/shared/utils'
import Button from '../../button'
import OverList from '../overList'
import { GET_RECENT_OVER } from '@/graphql/match/match.subscription'
import oversVector from '../../../../assets/images/error-images/overs.svg'
import NoData from '../../noData'

const MatchDetailOvers = ({ data, matchDetail, is100 }: any) => {
  const [selectedTab, setSelectedTab] = useState(matchDetail?.nLatestInningNumber)
  const [enablebtn, setEnableBtn] = useState(data?.listMatchOvers?.aResults?.length >= 5)
  const isNext = useRef(data?.listMatchOvers?.aResults?.length >= 5)
  const loading = useRef(false)
  const btnDisabled = useRef(false)
  const [overData, setOverData] = useState(data?.listMatchOvers?.aResults)
  const payloads = useRef({
    iMatchId: matchDetail?._id,
    nLimit: 5,
    nInningNumber: matchDetail?.nLatestInningNumber,
    sOver: null,
    isFront: true
  })
  const [getMoreOvers] = useLazyQuery(RECENT_OVER, { fetchPolicy: 'network-only' })
  useSubscription(GET_RECENT_OVER, {
    skip: true,
    variables: {
      input: { iMatchId: matchDetail?._id, nInningNumber: matchDetail?.nLatestInningNumber }
    },
    onData: ({ data }) => {
      const over = data?.data?.listMatchOvers
      if (over && over?.nInningNumber === payloads.current.nInningNumber) {
        if (overData[0]?.sOver === over?.sOver) {
          setOverData(
            overData?.map((item: any) => {
              if (item?.sOver === over?.sOver) {
                return { ...item, aBall: over?.aBall }
              }
              return item
            })
          )
        } else {
          setOverData([over, ...overData])
        }
      }
    }
  })

  const handleLoadMore = () => {
    payloads.current = { ...payloads.current, nInningNumber: selectedTab }
    getMoreOvers({ variables: { input: { ...payloads.current } } }).then(updatedOverData => {
      updatedOverData.data &&
        setOverData([
          ...overData,
          // eslint-disable-next-line no-unsafe-optional-chaining
          ...(updatedOverData.data?.listMatchOvers?.aResults.length
            ? updatedOverData.data?.listMatchOvers?.aResults
            : [])
        ])
    })
    setEnableBtn(false)
    btnDisabled.current = true
  }

  const handleInning = (inning: any) => {
    if (selectedTab !== inning?.nInningNumber) {
      setSelectedTab(inning.nInningNumber)
      payloads.current = { ...payloads.current, nInningNumber: inning.nInningNumber, sOver: null }
      getMoreOvers({ variables: { input: { ...payloads.current } } }).then(updatedOverData => {
        if (updatedOverData?.data) {
          setOverData(updatedOverData?.data?.listMatchOvers?.aResults)
          isNext.current = updatedOverData.data?.listMatchOvers?.aResults?.length >= 5
        }
      })
      setEnableBtn(true)
      btnDisabled.current = false
    }
  }

  useEffect(() => {
    // get last over from overData
    const lastItem = overData[Object.keys(overData)[Object.keys(overData).length - 1]]
    payloads.current.sOver = lastItem?.sOver
    if (btnDisabled.current) {
      loading.current = false
      const tempId =
        overData[overData.length - 1]?.sOver + overData[overData.length - 1]?.nInningNumber
      isBottomReached(tempId, isReached)
    }
  }, [overData])

  async function isReached(reach: any) {
    if (reach && !loading.current && isNext.current) {
      loading.current = true
      setPayload()
      getMoreOvers({ variables: { input: { ...payloads.current } } }).then(updatedOverData => {
        if (updatedOverData.data) {
          // eslint-disable-next-line no-unsafe-optional-chaining
          setOverData([...overData, ...updatedOverData.data?.listMatchOvers?.aResults])
          isNext.current = updatedOverData.data?.listMatchOvers?.aResults?.length >= 5
        }
      })
    }
  }

  function setPayload() {
    payloads.current = { ...payloads.current }
  }

  return (
    <>
      {!(matchDetail && overData?.length > 0) ? (
        <NoData imagePath={oversVector} />
      ) : (
        <>
          <div className={`flex gap-4 mb-4 flex-nowrap whitespace-nowrap overflow-auto`}>
            {matchDetail?.aInning?.map((data: any, i: number) => {
              return (
                <div
                  key={`${data?.sShortName}-${i}`}
                  className={`${
                    selectedTab !== data?.nInningNumber
                      ? 'bg-theme text-textDselected cursor-pointer'
                      : ' !bg-buttonBg border-buttonBg dark:text-[#CED2D5] text-white cursor-default font-medium'
                  } text-center select-none px-2.5 sm:px-3  py-1.5 rounded-lg dark:bg-transparent bg-white w-fit border text-sm sm:text-base font-normal border-tabBorder hover:!bg-buttonBg hover:text-white`}
                  onClick={() => handleInning(data)}
                >
                  {data?.sShortName}
                </div>
              )
            })}
          </div>
          <div className="">
            {overData?.map((over: any, index: number) => {
              return (
                <React.Fragment key={index}>
                  <OverList is100={is100} data={over} id={over?.sOver + over?.nInningNumber} />
                </React.Fragment>
              )
            })}
          </div>
          {/* {overLoading && oversLoader()} */}
          {enablebtn && (
            <div className="text-center my-2">
              <Button onClick={() => handleLoadMore()}>Load More</Button>
            </div>
          )}
        </>
      )}
    </>
  )
}

MatchDetailOvers.propTypes = {
  data: PropTypes.object,
  matchDetail: PropTypes.object,
  is100: PropTypes.bool
}

export default MatchDetailOvers
